import React, { useMemo, useState } from 'react';
import axios from 'helpers/api';
import { useEffect } from 'react'
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableMedRecList from 'components/common/advance-table/AdvanceTableMedRecList';
import paths from 'routes/paths';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import moment from "moment";
import { Link } from 'react-router-dom';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Form, Row, Toast } from 'react-bootstrap';
import { toast } from 'react-toastify';


const MedicalRecordTablePrescription = (props) => {
    const [showDiscModal, setShowDiscModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [discontinueLoading, setDiscontinueLoading] = useState(false);
    const [formFlags, setFormFlags] = useState(null);
    const [loading , setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('active');
    const [refetchData, setFetchData] = useState(false);
    const columns = [
        {
            accessorKey: 'medrecord_id',
            header: 'Medical Record ID',
            meta: {
                headerProps: { className: 'pe-1 text-900' }
            },
            // cell: ({ row: { original } }) => { 
            //     return <Link to={{ pathname: paths.editMedicalRecord }} state={{
            //         dataObj : original,
            //         flagsObj : formFlags,
            //         prescription_id : original.prescription_id,
            //         medrecord_id: original.medrecord_id, patientid: original.patientid, facilityid: original.facilityid
            //     }} >{original.medrecord_id}</Link>
            // }

             cell: ({ row: { original } }) => { 
                const editMedicalRecord = paths.editMedicalRecord;
                const path = `${editMedicalRecord}/${original.medrecord_id}`
                return <Link to={{ pathname: path}} 
                    state={{
                    dataObj : original,
                    flagsObj : formFlags,
                    medrecord_id: original.medrecord_id, 
                    patientid: original.patientid, facilityid: original.facilityid
                }} >{original.medrecord_id}</Link>
            }
        },
        {
            accessorKey: 'category',
            header: 'Category',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'start',
            header: 'Start Date',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        {
            accessorKey: 'stop',
            header: 'Stop Date',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        // {
        //     accessorKey: 'medsheet',
        //     header: 'Medsheet',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'treatment',
        //     header: 'Treatment',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'physician_order',
        //     header: 'Physician Order',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        {
            accessorKey: 'frequency',
            header: 'Frequency',
            meta: {
                headerProps: { className: 'text-900' }
            }
        },
        //  {
        //     accessorKey: 'discontinue',
        //     header: 'Disc Order',
        //     meta: { headerProps: { className: 'text-900 ' } },
        //     cell: ({ row: { original } }) => (
        //        original.is_active === 1 ? <button
        //             type="button"
        //             className="btn btn-link p-2"
        //             onClick={() => openDiscModal(original)}
        //             aria-label="Discontinue medical record"
        //             title="Discontinue medical record"
        //         >
        //             { <FontAwesomeIcon icon="plus" className="me-1 fs-11"/> }
        //         </button> : 'NA'
        //     )
        // },
        // {
        //     accessorKey: 'time1',
        //     header: 'Time 1',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'time2',
        //     header: 'Time 2',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'time3',
        //     header: 'Time 3',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // },
        // {
        //     accessorKey: 'time4',
        //     header: 'Time 4',
        //     meta: {
        //         headerProps: { className: 'text-900' }
        //     }
        // }
    ];
    //const [facility] = useState(facilityStaffData);
    const [medicalrecordPrescription, setMedicalRecordPrescription] = useState([]);
      const openDiscModal = (record) => {
    setSelectedRecord(record);
    setShowDiscModal(true);
  };
  const closeDiscModal = () => {
    setShowDiscModal(false);
    setSelectedRecord(null);
  };

  const handleConfirmDiscontinue = async () => {
    if (!selectedRecord) return;
    setDiscontinueLoading(true);
    try {
      const tokenStr = localStorage.getItem('accessToken');

      // Adjust endpoint/method/body to match your backend
        const data = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/patients/set-medical-record-inactive`,
            {
                id: selectedRecord.medrecord_id,
            },
            { headers: { Authorization: `Bearer ${tokenStr}` } }
        );
        if(data.status){
            toast.success("Medical Record Discontinued Successfully");
            closeDiscModal();
            setFetchData(!refetchData);
        }

    //   // Optimistic UI: remove the record from the table
    } catch (err) {
      console.error('Discontinue failed:', err);
      // optionally show a toast here
    } finally {
      setDiscontinueLoading(false);
    }
  };


    useEffect(() => {
        async function fetchData() {
            setLoading(true);
            try {
                let tokenStr = localStorage.getItem("accessToken");

                // Step 1: Fetch categories first and build the map
                // const catResponse = await axios.get(
                //     `${process.env.REACT_APP_SERVER_URL}/patients/list-medical-record-category`,
                //     { headers: { Authorization: `Bearer ${tokenStr}` } }
                // );

                // const medRecCat = {};
                // const catData = catResponse.data.data;
                // setFormFlags(catData[0]);
                // catData.forEach((value) => {
                //     medRecCat[value.id] = value.code;
                // });

                // Step 2: Now map record data using the populated category map
                const results = [];
                props.recordData.forEach((value) => {
                    results.push({
                        medrecord_id: value.id,
                        category_id: value.medical_record_category_id,
                        category: value.medical_record_category_desc,
                        start: value.start_date != null ? moment(value.start_date, 'MM/DD/YYYY').format('MM/DD/YY') : null,
                        stop: value.stop_date != null ? moment(value.stop_date, 'MM/DD/YYYY').format('MM/DD/YY') : null,
                        description: value.description,
                        patientid: props.patientid,
                        prescription_id: value.prescription_id,
                        facilityid: props.facilityid,
                        medsheet: value.mar_flag ? "Y" : "N",
                        treatment: value.tar_flag ? "Y" : "N",
                        physician_order: value.po_order ? "Y" : "N",
                        frequency: value.frequency_name,
                        time1: value.time1,
                        time2: value.time2,
                        time3: value.time3,
                        time4: value.time4,
                        verifiedby: value.verified_by,
                        verified: value.verified_date,
                        is_active: value.is_active
                    });
                });

                setMedicalRecordPrescription(results);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        }

        fetchData();
    }, [refetchData]);

    const filteredData = useMemo(() => {
    if (statusFilter === 'all') return medicalrecordPrescription;
    if (statusFilter === 'active') return medicalrecordPrescription.filter(r => Number(r.is_active) === 1);
    return medicalrecordPrescription.filter(r => Number(r.is_active) === 0); // inactive
  }, [medicalrecordPrescription, statusFilter]);

    const table = useAdvanceTable({
        data: filteredData,
        columns,
        selection: false,
        sortable: true,
        pagination: true
    });

    return (
        <>
            <Row className="align-items-end mb-3">
                <Col md={3}>
                    <Form.Group>
                        <Form.Label>Filter</Form.Label>
                        <Form.Select
                            name="statusFilter"
                            value={statusFilter}
                            onChange={(e) => setStatusFilter(e.target.value)}
                            size="sm"
                        >
                            <option value="active">Active</option>
                            <option value="inactive">Discontinued</option>
                            <option value="all">All Medical Records</option>
                        </Form.Select>
                    </Form.Group>
                </Col>
                <Col md={6} className="d-flex flex-column mb-2">
                    <div className="d-flex flex-wrap align-items-center gap-4">
                        <div className="d-flex align-items-center gap-2">
                            <span
                                className="legend-active"
                                style={{ width: '25px', height: '25px', display: 'inline-block' }}
                            ></span>
                            <span className="fs-11 text-muted">Active</span>
                        </div>

                        {/* <div className="d-flex align-items-center gap-1">
                                            <span
                                                className="legend-unverified rounded"
                                                style={{ width: '25px', height: '25px', display: 'inline-block' }}
                                            />
                                            <small className="text-muted">Unverified</small>
                                        </div> */}

                        <div className="d-flex align-items-center gap-1">
                            <span
                                className="legend-discontinued rounded"
                                style={{ width: '25px', height: '25px', display: 'inline-block' }}
                            />
                            <small className="text-muted">Discontinued</small>
                        </div>
                    </div>
                </Col> 
            </Row>
            {loading ? <ShimmerUI /> : <>
                    {filteredData.length > 0 ?
                        <AdvanceTableProvider {...table}>
                            <AdvanceTableMedRecList
                                headerClassName="bg-200 text-nowrap align-middle text-center"
                                rowClassName="text-nowrap align-middle text-center"
                                tableProps={{
                                    size: 'lg',
                                    striped: true,
                                    className: 'fs-10 mb-0'
                                }}
                            />
                            <div className="mt-3">
                                <AdvanceTableFooter
                                    rowInfo
                                    navButtons
                                    rowsPerPageSelection
                                />
                            </div>
                        </AdvanceTableProvider> :
                        <p className="text-danger text-center fw-bold">No data available in table</p>}
                </>
            }
            {showDiscModal && (
                <>
                    <div
                        className="modal-backdrop fade show"
                        style={{
                            zIndex: 1040,
                            backdropFilter: 'blur(2px)',
                            backgroundColor: 'rgba(17,24,39,0.35)'
                        }}
                        onClick={!discontinueLoading ? closeDiscModal : undefined}
                    />
                    <div
                        className="modal fade show"
                        style={{ display: 'block', zIndex: 1050 }}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="discModalTitle"
                    >
                        <div
                            className="modal-dialog modal-dialog-centered"
                            style={{
                                transform: 'translateY(0)',
                                transition: 'transform 160ms ease, opacity 160ms ease',
                                opacity: 1,
                                maxWidth: 520
                            }}
                        >
                            <div
                                className="modal-content"
                                style={{
                                    border: 0,
                                    borderRadius: '1rem',
                                    boxShadow:
                                        '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)'
                                }}
                            >
                                <div
                                    className="modal-header"
                                    style={{ border: 0, paddingBottom: 0 }}
                                >
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 8
                                        }}
                                    >
                                        <span
                                            style={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 6,
                                                backgroundColor: 'rgba(220,53,69,0.12)',
                                                color: '#b42318',
                                                borderRadius: 999,
                                                padding: '4px 8px',
                                                fontSize: 12,
                                                fontWeight: 600
                                            }}
                                        >
                                            <i className="fas fa-ban" style={{ fontSize: 12 }} />
                                            Confirm
                                        </span>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={closeDiscModal}
                                        aria-label="Close"
                                        disabled={discontinueLoading}
                                    />
                                </div>
                                <div className="modal-body" style={{ paddingTop: 12 }}>
                                    <h5
                                        id="discModalTitle"
                                        style={{ marginBottom: 8, color: '#0f172a', fontWeight: 700 }}
                                    >
                                        Discontinue Medical Record
                                    </h5>
                                    <p style={{ marginBottom: 6, color: '#334155' }}>
                                        Do you want to discontinue Medical Record ID{' '}
                                        <strong>{selectedRecord?.medrecord_id}</strong>?
                                    </p>
                                </div>
                                <div
                                    className="modal-footer"
                                    style={{ border: 0, paddingTop: 0, gap: 8 }}
                                >
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={closeDiscModal}
                                        disabled={discontinueLoading}
                                    >
                                        No, keep it
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-danger d-inline-flex align-items-center"
                                        onClick={handleConfirmDiscontinue}
                                        disabled={discontinueLoading}
                                        style={{ gap: 6 }}
                                    >
                                        {discontinueLoading && (
                                            <span
                                                className="spinner-border spinner-border-sm"
                                                role="status"
                                                aria-hidden="true"
                                                style={{ marginRight: 6 }}
                                            />
                                        )}
                                        Yes, discontinue
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default MedicalRecordTablePrescription;

